import { render } from "./BadgeNew.vue?vue&type=template&id=331a1371&scoped=true"
import script from "./BadgeNew.vue?vue&type=script&lang=js"
export * from "./BadgeNew.vue?vue&type=script&lang=js"

import "./BadgeNew.vue?vue&type=style&index=0&id=331a1371&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331a1371"],['__file',"src/common/components/BadgeNew/BadgeNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "331a1371"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('331a1371', __exports__)) {
    api.reload('331a1371', __exports__)
  }
  
  module.hot.accept("./BadgeNew.vue?vue&type=template&id=331a1371&scoped=true", () => {
    api.rerender('331a1371', render)
  })

}


export default __exports__